import React from "react";
import Modal from "../../Modal";
import { useDispatch } from "react-redux";
import {
  challengesStatus,
  getChallenges,
} from "../../../features/slices/challanges";
import { toastService } from "../../../utils/toastify";

const DeleteModal = ({ setUpdateState, upComingData }) => {
  const dispatch = useDispatch();
  const hanldeClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      deleteModalState: false,
    }));
  };
  const handleDelete = () => {
    const data = { id: upComingData?._id, status: "DELETED" };
    dispatch(challengesStatus(data)).then((data) => {
      if (data?.payload?.code === 200) {
        dispatch(getChallenges({ type: "Upcoming" })).then((data) => {
          if (data?.payload?.code === 200) {
            toastService.success("Status Deleted successfully");
            setUpdateState((prev) => ({
              ...prev,
              status: "",
            }));
            hanldeClose();
          } else {
            toastService.error(data?.payload?.message);
          }
        });
      }
    });
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Decline">
          <a className="CloseModal" onClick={hanldeClose}>
            ×
          </a>
          <h3>Delete</h3>
          <p>Are you sure you want to delete this Challenge &amp; Bounty ?</p>
          <h4>
            <a onClick={hanldeClose}>no</a>
            <a onClick={handleDelete}>Yes</a>
          </h4>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
